import ReactLoading, { LoadingType } from 'react-loading';

import './index.css'

type LoadingProps = {
    type: LoadingType | undefined;
    color: string;
    width: number | string;
    height: number | string;
}

export function Loading({type, color, width, height}: LoadingProps) {
    return (
        <div className="loading-all">
            <ReactLoading type={type} color={color} height={height} width={width} />
        </div>
    )
}